import React from "react";
import { cellGrow } from "constants/styles";
import Pill from "components/Pill";
import classnames from "classnames";
import { getCouponPillProps } from "utils/coupon";
import { STATUS, UI_THEME } from "utils/constants/ui";

const CouponOption = ({ model, isFirst, isLast, isActive, onClick }) => {
  const { id, name, discount, redemptions, currency, expiration } = model;
  const isDisabled = Boolean(model.disabled);
  const pillProps = getCouponPillProps(model);

  return (
    <div
      className={classnames(
        "hairline-1 ba br2 bg-white w-100 relative bg-white--hover",
        {
          "cell-grow": !isDisabled,
          "cursor-not-allowed o-80": isDisabled
        }
      )}
      onClick={() => !isDisabled && onClick(id)}
    >
      <div className="flex flex-column bb hairline-1 justify-between">
        <div
          className={classnames("ph2 pv2 flex flex-row justify-between", {
            pointer: !isDisabled
          })}
        >
          <div className="flex flex-row justify-between w-100 overflow-hidden">
            <div className="flex flex-column justify-between">
              <div className="f5 fw5 lh-title word-break">{name}</div>
              {expiration && (
                <div className="f7 pt1 lh-title word-break">{`Expires ${expiration}`}</div>
              )}
            </div>
            <div className="flex flex-column items-end flex-shrink-0">
              {discount && (
                <div className="f5 fw6 lh-title flex-shrink-0">
                  {`${discount} off`}
                </div>
              )}
              <div className="pt2">
                <Pill theme={UI_THEME.SLIM} copy={id} />
              </div>
            </div>
          </div>
        </div>
        <div style={{ height: 43 }} className="w-100"></div>
        <div className="absolute bottom-0 right-0 left-0 z-1 center flex flex-row justify-between items-center w-100 bt hairline-1 pa2 bg-white f6">
          <div className="flex flex-row items-center">
            {currency && (
              <div className="f7 lh-title truncate fw5 pr2">
                <Pill
                  theme={UI_THEME.SLIM}
                  copy={currency.toUpperCase()}
                  status={STATUS.NEUTRAL}
                />
              </div>
            )}
            <div className="f7 lh-title truncate fw5">
              <Pill {...pillProps} />
            </div>
          </div>
          <div className="f7 lh-title truncate fw5">{`Redeemed ${redemptions}`}</div>
        </div>
      </div>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

export default CouponOption;
